import { Box, Button, IconButton } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

/**
 * Base container for cart popover and empty state
 * Shared styling for cart components
 */
export const StyledCartContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(12),
}));

/**
 * Container for cart empty state
 * Extends base container with centered alignment
 */
export const StyledCartEmptyStateContainer = styled(StyledCartContainer)({
  alignItems: 'center',
});

/**
 * Close button for cart popover and empty state
 * Positioned absolutely in the top-right corner
 */
export const StyledCartCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(4),
  right: theme.spacing(4),
}));

/**
 * Checkout button for cart
 * Centered horizontally with auto margins
 */
export const StyledCartCheckoutButton = styled(Button)({
  marginInline: 'auto',
});
